import React from 'react'
import SearchFilter from './SearchFilter'
import bgVideo from '../assets/justoffplan-video.mp4'
import Properties from './Properties'
import { useTranslation } from 'react-i18next';



export default function HeroSection({
    // paddingClasses = 'pt-[660px] lg:pt-[220px]',
    sortBy = 'latest',
    getPropertyData,
    selectedCategory,
    setSelectedCategory,
    isLoading,
    projectOptions,
    communityOptions

}) {

    const { t, i18n } = useTranslation();

    return (
        <section className="relative h-[650px] overflow-hidden">

            {/* video background */}
            <div className="absolute inset-0 overflow-hidden pointer-events-none">
                <video
                    className="w-full h-full object-cover pointer-events-none"
                    src={bgVideo}
                    autoPlay
                    muted
                    loop
                    playsInline
                    poster="/assets/dubai-poster.jpg"
                />
                <div className="absolute inset-0 bg-black/50 pointer-events-none" />
            </div>

            {/* boxed main content */}
            <div className="relative z-10 flex h-full items-center justify-center px-4 mt-16">
                {/* limit width here */}
                <div className="max-w-4xl text-center">
                   <h1 className="text-white text-3xl md:text-5xl lg:text-6xl font-bold mb-4 leading-snug">
  {t('hero_title_main')}
  <span className="block text-yellow-500">{t('hero_title_highlight')}</span>
</h1>


                  <p className="text-gray-200 text-sm mt-10 md:text-lg lg:text-xl mb-8">
  {t('hero_subtitle_line1')}<br />
  {t('hero_subtitle_line2')}
</p>


<div className="flex flex-wrap justify-center gap-4 mt-20">
  <a
    href="/exclusive"
    className="px-4 py-2 text-sm md:px-6 md:py-3 md:text-base bg-teal-500 hover:bg-teal-600 text-white rounded-full transition"
  >
    {t('hero_browse_properties')}
  </a>
  <a
    href="/learn-more"
    className="px-4 py-2 text-sm md:px-6 md:py-3 md:text-base border border-white text-white rounded-full hover:bg-white hover:text-black transition"
  >
    {t('hero_learn_more')}
  </a>
</div>


                </div>
            </div>

            {/* search filter: mobile = in flow, desktop = absolute overlap */}
            <div
                className="
    w-full px-4 mt-4               /* mobile: in-flow with top margin */
    relative transform -translate-y-50  /* mobile: pull up ~2rem */
    md:translate-y-0              /* md+: cancel the translate */
    md:mt-0                       /* md+: remove extra top margin */
    md:absolute md:bottom-0 md:-mb-42 /* md+: original overlap */
    z-20 pointer-events-auto      /* ensure it sits above & receives clicks */  "
            >
                {/* <SearchFilter
                    getPropertyData={getPropertyData}
                    selectedCategory={selectedCategory}
                    setSelectedCategory={setSelectedCategory}
                    projectOptions={projectOptions}
                /> */}

            </div>
        </section>
    )
}
